import { useContext } from 'react'

import { MrpReabContext } from '@provider/Mrp/ReabProvider'

import type { IMrpReabContext } from '@base/@types/providers/Mrp/ReabProvider'

export default function useMrpReab(): IMrpReabContext {
  const context = useContext(MrpReabContext)

  return context
}
